import { Text, View } from '@react-pdf/renderer';
import { checkObjHasValues } from 'utils';

const Language = ({ styles, data = [], headerTitle }: any) => {
	return (
		<View style={styles.mainBox}>
			<View style={styles.headingBox}>
				<Text style={styles.heading}>{headerTitle}</Text>
			</View>

			<View style={styles.mainBoxInner}>
				{data?.map((res: any, index: number) => {
					if (checkObjHasValues(res)) {
						return (
							<View key={`lang-t2-${res?.name}-${index}`} style={styles.detailBox} wrap={false}>
								<View style={styles.detailBoxContent}>
									<Text style={styles.detailText}>{res?.name}</Text>
									{res?.proficiency && <Text style={styles.detailSubText}>{res.proficiency}</Text>}
								</View>
							</View>
						);
					}
				})}
			</View>
		</View>
	);
};

export default Language;
